import HTTP from './axios';

const PatientProfessionalService = {
  get: patientId => HTTP.get(`/patients/${patientId}/professionals`).then(response => response.data.data),
  add: (patientId, professionalId) => HTTP.post(`/patients/${patientId}/professionals/${professionalId}`).then(response => response.data.data),
  remove: (patientId, professionalId) => HTTP.put(`/patients/${patientId}/professionals/${professionalId}`).then(response => response.data.data),
  share: ({ patientId, professionalId, email }) => HTTP.post(`/patients/${patientId}/professionals/${professionalId}/share`, { email })
    .then(response => response.data.data),
};

export default PatientProfessionalService;
